document.querySelectorAll('[data-section-type="carousel"]').forEach(function(container){
  const loader = new WAU.Helpers.scriptLoader();
  loader.load([jsAssets.flickity]).finally(() => {
    setTimeout(function() {
      carouselInit(container);
    }, 200);
  });
});

document.addEventListener("shopify:section:load", function(event) {
  if ( !event.target.querySelector('[data-section-type="carousel"]') ) return false;
  setTimeout(function() {
    carouselInit(event.target);
  }, 200);
  adjustSlideshowHeight();
});

document.addEventListener("shopify:block:select", function(event) {
  var container = event.target.closest('[data-section-type]');

  if ( container.getAttribute('data-section-type') === 'carousel' ) {
    setTimeout(function() {
      carouselSlideEdit(event.target);
    }, 200);
  }
});

document.addEventListener("shopify:block:deselect", function(event) {
  var container = event.target.closest('[data-section-type]');
  if ( container.getAttribute('data-section-type') === 'carousel' ) {
    carouselSlideRestart(event.target);
    adjustSlideshowHeight();
  }
});

function carouselInit(container) {
  var carousel = container.querySelector('.js-carousel');

  if ( !carousel ) return false;

  if ( carousel.classList.contains('carousel-loaded--false') ) {
    carousel.classList.remove('carousel-loaded--false');
    carousel.classList.add('carousel-loaded--true');
  }

  const flktyData = carousel.getAttribute('data-flickity');
  const flktyOptions = JSON.parse(flktyData);
  const flktyInstance = new Flickity(carousel, flktyOptions);

  // Fix iOS touchmove issue
  fixTouchMoveIssue();

  // Prevent resize in Flickity if still animating
  preventResizeWhileAnimating(flktyInstance);

  carouselResize(carousel);

  // Carousel pagination
  var carouselPag = container.querySelector('.js-carousel-pagination');
  if ( !carouselPag ) return false;
  carouselPagination(carousel, carouselPag);
  
  // Calculate and set height for slideshow adjustment
  adjustSlideshowHeight();
}

function carouselSlideEdit(container) {
  var carousel = container.closest('.js-carousel');

  if ( !carousel ) return false;

  var flkty = Flickity.data(carousel);
  var slide = container.getAttribute("data-slider-index");
  flkty.select(slide);
  flkty.pausePlayer();
}

function carouselSlideRestart(container) {
  var carousel = container.closest('.js-carousel');

  if ( !carousel ) return false;

  const flkty = Flickity.data(carousel);
  flkty.unpausePlayer();
}

function carouselResize(carousel) {
  var flkty = Flickity.data(carousel);
  flkty.resize();
}

function carouselPagination(carousel, pagination) {
  var flkty = Flickity.data(carousel);

  flkty.on( 'select', function() {
    var slideNumber = flkty.selectedIndex + 1;
    pagination.textContent = '(' + slideNumber + ' of ' + flkty.slides.length + ')';
  });
}

function adjustSlideshowHeight() {
  const topBar = document.querySelector('.js-top-bar');
  const themeHeader = document.querySelector('.header__over-content--false');

  let topBarHeight = topBar ? topBar.offsetHeight : 0;
  let themeHeaderHeight = themeHeader ? themeHeader.offsetHeight : 0;
  let combinedHeight = topBarHeight + themeHeaderHeight;

  document.querySelectorAll('.js-section-slideshow').forEach(function(slideshow) {
    slideshow.style.setProperty('--slideshow-offset', `${combinedHeight}px`);
  });
}

// Fix iOS touchmove issue
function fixTouchMoveIssue() {
  let touchingCarousel = false;
  let startXCoordinate;

  document.body.addEventListener('touchstart', function(e) {
    if (e.target.closest('.flickity-slider')) {
      touchingCarousel = true;
    } else {
      touchingCarousel = false;
      return;
    }
    startXCoordinate = e.touches[0].pageX;
  });

  document.body.addEventListener('touchmove', function(e) {
    if (!touchingCarousel || !e.cancelable || Math.abs(e.touches[0].pageX - startXCoordinate) < 8) return;
    e.preventDefault();
    e.stopPropagation();
  }, { passive: false });
}

// Prevent resize in Flickity if still animating
function preventResizeWhileAnimating(flktyInstance) {
  var originalResize = flktyInstance.resize;
  flktyInstance.resize = function() {
    if (!this.isAnimating) {
      originalResize.call(this);
    }
  };
}

// Initial adjustment
adjustSlideshowHeight();

// Optional: Adjust on resize
window.addEventListener('resize', adjustSlideshowHeight);
